<template>
  <b-modal
    centered
    :hide-footer="true"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    content-class="c-content2"
    header-class="popup_header1"
    body-class="container c-body"
    :visible="visible"
    @show="onShow"
    @hide="hide"
  >
    <template #modal-header="{ close }">
      <span style="margin: auto">{{$t('more.setting')}}</span>
      <b-img class="mo_close_btn"  @click="hide" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
<!--    <div class="leftright row" style="margin-top: 48px;">-->
<!--      <div class="text">{{$t('more.push_vibration')}}</div>-->
<!--      <CSwitch-->
<!--        v-model="pushVibration"-->
<!--        @change="setPush($event,'vibrate')"-->
<!--      />-->
<!--    </div>-->
<!--    <div class="leftright row" style="margin-top: 54px;">-->
<!--      <div class="text">{{$t('more.push_noti')}}</div>-->
<!--      <CSwitch-->
<!--        v-model="push"-->
<!--        @change="setPush($event,'normal')"-->
<!--      />-->
<!--    </div>-->
<!--    <div class="row" style="margin-top: 54px;">-->
<!--      <div class="text">{{$t('more.set_noti_disturb')}}</div>-->
<!--    </div>-->
<!--    <div style="margin-top: 22px;" class="leftright row">-->
<!--      <div class="leftright">-->
<!--        <b-form-timepicker v-model="pushStartTime"-->
<!--                           button-only-->
<!--                           button-variant="time"-->
<!--                           locale="ko"-->
<!--                           class="time_wrapper"-->
<!--        >-->
<!--          <div slot="button-content">-->
<!--            <div class="time_label">{{$t('more.start_time')}}</div>-->
<!--            <div class="time">{{pushStartTime.substr(0,5)}}</div>-->
<!--          </div>-->
<!--        </b-form-timepicker>-->
<!--        <b-form-timepicker v-model="pushEndTime"-->
<!--                           button-only-->
<!--                           button-variant="time"-->
<!--                           locale="ko"-->
<!--                           class="time_wrapper"-->
<!--                           style="margin-left: 10px"-->
<!--        >-->
<!--          <div slot="button-content">-->
<!--            <div class="time_label">{{$t('more.end_time')}}</div>-->
<!--            <div class="time">{{pushEndTime.substr(0,5)}}</div>-->
<!--          </div>-->
<!--        </b-form-timepicker>-->
<!--      </div>-->
<!--      <b-button @click="onSavePushOffTime" class="apply-btn">{{$t('common.apply1')}}</b-button>-->
<!--    </div>-->
<!--    <div class="divider"/>-->
    <div @click="showProfilePopup = true" class="row row_btn" style="margin-top: 20px;">
      {{$t('more.set_my_info')}}
    </div>
    <div @click="showPointPopup = true" class="row row_btn">
      {{$t('more.point_history')}}
    </div>
    <div @click="onLogout" class="row row_btn">
      {{$t('more.logout')}}
    </div>
    <div @click="showExitPopup = true" class="row row_btn">
      {{$t('more.withdrawal')}}
    </div>
    <SetMyInfoPopup
      :visible.sync="showProfilePopup"
    />
    <PointHistoryPopup
      :visible.sync="showPointPopup"
    />
    <ConfirmExitPopup
      :visible.sync="showExitPopup"
    />
  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
import CSwitch from "../CSwitch";
import PointHistoryPopup from "./PointHistoryPopup";
import SetMyInfoPopup from "./SetMyInfoPopup";
import ConfirmExitPopup from "./ConfirmExitPopup";

const u = require('util');


export default {
  name: "SettingPopup",
  components:{
    CSwitch,
    PointHistoryPopup,
    SetMyInfoPopup,
    ConfirmExitPopup
  },
  inject: ['eventBus'],
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      push:'N',
      pushVibration:'N',
      pushStartTime:'',
      pushEndTime:'',
      showProfilePopup:false,
      showPointPopup:false,
      showExitPopup:false,
    }
  },
  methods:{
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },
    hide(){
      if(window.history.state == "forward")
        window.history.back();
    },
    sync(){
      this.push = this.myinfo.push;
      this.pushVibration = this.myinfo.pushVibration;
      this.pushStartTime = this.myinfo.pushStartTime;
      this.pushEndTime = this.myinfo.pushEndTime;
    },
    iSync(){
      this.myinfo.push = this.push;
      this.myinfo.pushVibration = this.pushVibration;
      this.myinfo.pushStartTime = this.pushStartTime;
      this.myinfo.pushEndTime =  this.pushEndTime;
    },

    setPush(state, type){
      Utils.requestPost(
        this.$c.API.User.updatePushSetting,
        {
          push: type === 'normal' ? state : this.push,
          push_sound: type === 'vibrate' ? state : this.pushVibration,
          push_vibration: type === 'vibrate' ? state : this.pushVibration,
          push_off_start_time: this.pushStartTime,
          push_off_end_time: this.pushEndTime,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
          if (type == 'normal')
            this.push = this.push === 'Y' ? 'N' : 'Y';
          else
            this.pushVibration = this.pushVibration === 'Y' ? 'N' : 'Y';
          this.iSync();
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onSavePushOffTime() {
      this.iSync();
      Utils.requestPost(
        this.$c.API.User.updatePushSetting,
        {
          push: this.myinfo.push,
          push_sound: this.myinfo.pushVibration,
          push_vibration: this.myinfo.pushVibration,
          push_off_start_time: this.myinfo.pushStartTime.length == 5 ? this.myinfo.pushStartTime + ":00" : this.myinfo.pushStartTime,
          push_off_end_time: this.myinfo.pushEndTime.length == 5 ? this.myinfo.pushEndTime + ":00" : this.myinfo.pushEndTime,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this,this.$t('admin_point_setting.msg_update_success'));
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    onLogout(){
      Utils.showConfirm(
        this,
        this.$t('more.logout_confirm')).then(result => {
          if(result){
            Utils.requestPost(this.$c.API.User.logout, {})
              .then(() => {
                this.myinfo.clear();
                this.$perf.setString(this.$c.PREF_PARAMS.PHONE, '');
                this.$perf.setString(this.$c.PREF_PARAMS.CODE, '');
                this.$perf.setString('accessToken', '');

                this.$emit('update:visible', false);
                this.$router.push('login');

              });
          }
      });
    },
  },
  computed:{
  },
  watch:{
    visible(){
      if (this.visible)
        this.sync();
      else this.myinfo.saveInfo();
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
.row{
  padding:0 28px;
}
.row_btn{
  @extend .text;
  height: 62px;
  width: 100%;
}

.time_wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 96px;
  height: 94px;
  background-color: #f3f3f4;
  border-style: solid;
  border-width: 0.5px;
  border-color: #e8e7e7;
  border-radius: 8px;
}

.btn-time{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 96px;
  height: 94px;
  background-color: #f3f3f4;
  border-style: solid;
  border-width: 0.5px;
  border-color: #e8e7e7;
  border-radius: 8px;
}

.btn-time-no-padding{
  @extend .btn-time;
  padding:0;
}

.time_label {
  text-align: center;
  color: $c_457fff; font-size: $fs_12; font-family: $korean_gd_15_r; };

.time{color: $black; font-size: $fs_22; font-family: $korean_gd_11_r};

.apply-btn{
  width: 50px;
  height: 27px;
  border-radius: 2px;
  background-color: $c_457fff;
  font-size: 12.5px;
  font-family: $korean_gd_15_r;
};

.text{color: $black; font-size: $fs_18; font-family: $korean_gd_15_r};
.divider{background-color: #f9f9f9; height: 10px; margin-top: 55px; margin-bottom: 57px; margin-left: -2em; margin-right: -1em;};

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SettingPopup.vue